import ActivePrizeCertificateLine from './ActivePrizeCertifcateLine';
import ActivePrizeCertificateRenderer from './ActivePrizeCertificateSummaryRenderer';
import AdditionalGiftCardRenderer from './AdditionalGiftCardSummaryRenderer';
import AdditionalSummary from './AdditionalSummaryLine';
import AdditionalSummaryRenderer from './AdditionalSummaryRenderer';
import ShippingSummary from './ShippingSummary';
import SubTotalSummary from './SubTotalSummary';
import TotalDiscountSummary from './TotalDiscountSummary';
import TotalPriceSummary from './TotalPriceSummary';
import VoucherSummaryRenderer from './VoucherSummaryRenderer';

const SummaryLine = {
    SubTotalSummary,
    TotalDiscountSummary,
    AdditionalSummary,
    AdditionalSummaryRenderer,
    ShippingSummary,
    VoucherSummaryRenderer,
    AdditionalGiftCardRenderer,
    ActivePrizeCertificateLine,
    ActivePrizeCertificateRenderer,
    TotalPriceSummary
};

export default SummaryLine;
